<template>
    <div id="contenedor-eliminar-contrato-archivos-contratista">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar Archivo </v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar el archivo {{ contratoArchivoContratistaEliminar.descripcion }}?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarContratoArchivoContratista"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import mixArchivosContratista from './mixArchivosContratista';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarArchivosContratista',
  mixins: [mixArchivosContratista],
  props: {
    contratoArchivoContratistaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style></style>
